module.exports = __webpack_public_path__ + "img/yangshengbaojianpin_shrz.9ff32413.png";